import { render, staticRenderFns } from "./m-attach.vue?vue&type=template&id=4ab0b716"
import script from "./m-attach.vue?vue&type=script&lang=js"
export * from "./m-attach.vue?vue&type=script&lang=js"
import style0 from "./m-attach.vue?vue&type=style&index=0&id=4ab0b716&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports